import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PatchOrganisationRequestType,
  PatchOrganisationResponseType,
} from '../types';

export const patchOrganisation = async ({
  pathParams: { organisationId },
  bodyParams,
}: PatchOrganisationRequestType) => {
  const url = `/api/v2/organisations/${organisationId}`;
  const { data } = await apiAuthClient.patch<PatchOrganisationResponseType>(
    url,
    bodyParams,
  );
  return data.data;
};
